import React from 'react';
import { Container, Card, CardBody, Col } from 'reactstrap'
import classNames from "classnames";
import BrandedIcon from '../../BrandingWhiteLabel/BrandedIcon';

const InvalidCoverageError = ({ styles, accountName, languageCode , headerContent}) => {
 
  return (
    <Container className="contentWrapper">
        <Card>
            <CardBody className={classNames(styles.processingCert, "m-5")}>
              <BrandedIcon accountName={accountName} iconType={'error'} />
              <h1 className="h3 pt-5">{"Our system is unable to process your request."}</h1>
              <p className="text-center">
                {`If issues persist contact Customer Support at ${headerContent?.CustomerServicePhone_content}`}
              </p> 
            </CardBody>
        </Card>
    </Container>
  )
}

export default InvalidCoverageError;